import ApiClient from "../ApiClient";
import PaymentRequestFilter from "../../models/admin/payment-request/PaymentRequestFilter";
import PaymentRequestFilterValue from "../../models/admin/payment-request/PaymentRequestFilterValue";
import PaymentRequestListPagedResult from "../../models/admin/payment-request/PaymentRequestListPagedResult";
import PaymentRequestList from "../../models/admin/payment-request/PaymentRequestList";
import PaymentRequestDetails from "../../models/admin/payment-request/PaymentRequestDetails";
import PaymentRequestStudentDetails from "../../models/admin/payment-request/PaymentRequestStudentDetails";
import PaymentRequestSchoolCarrierDetails from "../../models/payment-request/PaymentRequestSchoolCarrierDetails";
import PaymentRequestAuthorizedCarrierDetails from "../../models/payment-request/PaymentRequestAuthorizedCarrierDetails";

export default class PaymentRequestApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "admin/payment-requests/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getSearchFilters(schoolTypeId: number) {
    const filters = await this.apiClient.get(
      `${this.urlPrefix}search/filters?schoolTypeId=${schoolTypeId}`
    );

    return filters as PaymentRequestFilter;
  }

  async search(
    filter: PaymentRequestFilterValue,
    page?: number,
    pageItems?: number
  ) {
    const requests = await this.apiClient.get(
      `${this.urlPrefix}search?page=${page}` +
        `&pageSize=${pageItems}` +
        `&schoolTypeId=${filter.schoolTypeId}` +
        `&schoolId=${filter.schoolId || ""}` +
        `&status=${filter.status || ""}` +
        `&schoolYearId=${filter.schoolYearId}` +
        `&date=${filter.date}` +
        (filter.excludeStatus ? `&excludeStatus=${filter.excludeStatus}` : "")
    );

    return requests as PaymentRequestListPagedResult<PaymentRequestList>;
  }

  async getDetails(id: string) {
    const details = await this.apiClient.get(`${this.urlPrefix}${id}/details`);

    return details as PaymentRequestDetails;
  }

  async updateStatus(id: number, statusId: number, changeReason: string) {
    await this.apiClient.put(`${this.urlPrefix}${id}/status`, {
      statusId: statusId,
      changeReason: changeReason,
    });
  }

  async updateStatuses(filter: PaymentRequestFilterValue) {

    const dto = {
      ...filter,
      schoolId:
        filter.schoolId === "" ? null :
        (typeof filter.schoolId === "string" ? Number(filter.schoolId) : filter.schoolId),

      schoolYearId:
        filter.schoolYearId === "" ? null :
        (typeof filter.schoolYearId === "string" ? Number(filter.schoolYearId) : filter.schoolYearId),

      date: filter.date === "" ? null : filter.date,
    };
    await this.apiClient.put(`${this.urlPrefix}status`, dto);
  }

  async updateCorrectedCosts(
    id: number,
    studentDetails: PaymentRequestStudentDetails[],
    schoolCarrierDetails: PaymentRequestSchoolCarrierDetails[],
    authorizedCarrierDetails: PaymentRequestAuthorizedCarrierDetails[]
  ) {
    await this.apiClient.put(`${this.urlPrefix}${id}/corrected-cost`, {
      studentCorrectedCosts: studentDetails,
      schoolCarrierCorrectedCosts: schoolCarrierDetails,
      authorizedCarrierCorrectedCosts: authorizedCarrierDetails,
    });
  }

  async getCanStatusReturnRequest(paymentRequestId: number) {
    const respons = await this.apiClient.get(
      this.urlPrefix + `can-return-request?paymentRequestId=${paymentRequestId}`
    );
    return respons as boolean;
  }
}
